import { useMutation } from '@tanstack/react-query';
import {
  updateAgent,
  createAgent,
  getAgentsByQuery,
  getArchivedAgentsByQuery,
  archiveAgent,
  getAgentById,
  archivedFeessAgent,
  pushToArray,
  archivedExpensesAgent,
  updateAgentItem,
  updateAgentItemBulk,
  reassignAutoAgent,
} from '../requests/agent';

const KEY = 'agent';

const useGetAgents = () => useMutation({
  mutationKey: [KEY, 'getAgents'],
  mutationFn: (data) => getAgentsByQuery(data),
});

const useGetArchivedAgents = () => useMutation({
  mutationKey: [KEY, 'getArchivedAgents'],
  mutationFn: (data) => getArchivedAgentsByQuery(data),
});

const useGetOne = () => useMutation({
  mutationKey: [KEY, 'getOne'],
  mutationFn: (data) => getAgentById(data),
});

const useUpdateAgent = () => useMutation({
  mutationKey: [KEY, 'update'],
  mutationFn: (data) => updateAgent(data),
});

const useCreateAgent = () => useMutation({
  mutationKey: [KEY, 'create'],
  mutationFn: (data) => createAgent(data),
});

const useArchiveAgent = () => useMutation({
  mutationKey: [KEY, 'archive'],
  mutationFn: (data) => archiveAgent(data),
});

const useArchivedExpensesAgent = () => useMutation({
  mutationKey: [KEY, 'archivedExpensesAgent'],
  mutationFn: (data) => archivedExpensesAgent(data),
});

const useArchivedFeesAgent = () => useMutation({
  mutationKey: [KEY, 'archivedFeesAgent'],
  mutationFn: (data) => archivedFeessAgent(data),
});

const usePushToArray = () => useMutation({
  mutationKey: [KEY, 'addAgreement'],
  mutationFn: (data) => pushToArray(data),
});

const useUpdateAgentItem = () => useMutation({
  mutationKey: [KEY, 'editOneByAgent'],
  mutationFn: (data) => updateAgentItem(data),
});

const useUpdateAgentItemBulk = () => useMutation({
  mutationKey: [KEY, 'editManyByAgent'],
  mutationFn: (data) => updateAgentItemBulk(data),
});

const useReassignAutoAgent = () => useMutation({
  mutationKey: [KEY, 'reassignAutoAgent'],
  mutationFn: (data) => reassignAutoAgent(data),
});

const agentMutations = {
  useGetAgents,
  useGetArchivedAgents,
  useUpdateAgent,
  useCreateAgent,
  archiveAgent,
  useArchiveAgent,
  useArchivedExpensesAgent,
  useGetOne,
  usePushToArray,
  useArchivedFeesAgent,
  useUpdateAgentItem,
  useUpdateAgentItemBulk,
  useReassignAutoAgent,
};

export default agentMutations;
